/* eslint-disable */
export const version = '29.23.0';
